import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-background',
  templateUrl: './public-background.component.html',
  styleUrls: ['./public-background.component.scss']
})
export class PublicBackgroundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/public-background/public-background.component.ts